export enum AssignmentCategory {
  CORE = "CORE",
  TEACHER_ASSIGNED = "TEACHER_ASSIGNED",
  AI = "AI",
  ROLLOVER = "ROLLOVER",
  PREREQUISITE = "PREREQUISITE"
}
